import React, { Component } from "react";

class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <a href="https://www.fenamix.org/">
                        <li>
                            <img src="/assets/images/brand/fenamix.png" alt="Logo Images"/>
                        </li>
                    </a>
                    <a href="https://visitatamaulipas.com/">
                        <li>
                            <img src="/assets/images/brand/tamaulipas2.png" alt="Logo Images"/>
                        </li>
                    </a>
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;